import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Users, Clock, Calendar, TrendingUp, DollarSign } from 'lucide-react';
import { PageHeader } from '../../components/layout';
import { Card, CardBody } from '../../components/common';
import './Reports.css';

const reports = [
    {
        title: 'Purchase Order Report',
        description: 'View and analyze all purchase orders by status, date, and vendor',
        icon: FileText,
        path: '/reports/purchase-orders',
        color: '#2563eb'
    },
    {
        title: 'Vendor Performance',
        description: 'Evaluate vendor performance based on delivery, quality, and response time',
        icon: Users,
        path: '/reports/vendor-performance',
        color: '#10b981'
    },
    {
        title: 'Invoice Aging',
        description: 'Track overdue invoices and payment status',
        icon: Clock,
        path: '/reports/invoice-aging',
        color: '#f59e0b'
    },
    {
        title: 'Contract Expiry',
        description: 'Monitor contracts nearing expiration',
        icon: Calendar,
        path: '/reports/contract-expiry',
        color: '#ef4444'
    },
    {
        title: 'Savings Analysis',
        description: 'Analyze cost savings from procurement activities',
        icon: DollarSign,
        path: '/reports/savings',
        color: '#8b5cf6'
    },
    {
        title: 'Cycle Time',
        description: 'Measure procurement process efficiency',
        icon: TrendingUp,
        path: '/reports/cycle-time',
        color: '#06b6d4'
    }
];

export default function ReportsDashboard() {
    return (
        <div className="reports-dashboard">
            <PageHeader
                title="Reports & Analytics"
                subtitle="Generate and analyze procurement reports"
                breadcrumbs={[{ label: 'Reports', path: '/reports' }]}
            />

            <div className="reports-grid">
                {reports.map((report) => (
                    <Link key={report.path} to={report.path} className="report-card-link">
                        <Card className="report-card">
                            <CardBody>
                                <div className="report-icon" style={{ backgroundColor: `${report.color}15`, color: report.color }}>
                                    <report.icon size={24} />
                                </div>
                                <h3>{report.title}</h3>
                                <p>{report.description}</p>
                            </CardBody>
                        </Card>
                    </Link>
                ))}
            </div>
        </div>
    );
}
